module.exports = __webpack_public_path__ + "static/media/supprimer-cercle.c3294e90.png";